declare let ENVIRONMENT: string;
declare let APP_DOMAIN: string;
declare let API_DOMAIN: string;

export default class WorkspaceUtils {
  static sslEnabled() {
    return ENVIRONMENT != 'development';
  }

  static protocolPrefix() {
    return this.sslEnabled() ? 'https' : 'http';
  }

  static getApiDomain() {
    return API_DOMAIN;
  }

  static getAppDomain() {
    return APP_DOMAIN;
  }

  static workspaceApiUrl(workspace) {
    // assert workspace is not undefined
    return `${this.protocolPrefix()}://${workspace}.api.${this.getApiDomain()}`;
  }

  static parseWorkspaceName(hostname) {
    return hostname.split('.')[0];
  }

  static commonApiUrl() {
    return `${this.protocolPrefix()}://api.${this.getApiDomain()}`;
  }

  static getWorkspaceUrl(
    workspace,
    forwardPath: string | undefined = undefined
  ) {
    let output = `${this.protocolPrefix()}://${workspace}.${this.getAppDomain()}`;
    if (!!forwardPath) {
      output += forwardPath;
    }
    return output;
  }

  static getCommonUrl() {
    return `${this.protocolPrefix()}://app.${this.getAppDomain()}`;
  }

  static getSuffix() {
    return new RegExp(
      `${this.protocolPrefix()}:\\/\\/(.*).${this.getAppDomain()}`
    );
  }

  static dataPassing(data) {
    return btoa(JSON.stringify(data));
  }
}
